var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex flex-col relative md:pt-6"},[_c('NotFound',{attrs:{"title":_vm.$t('message.page-not-found'),"description":_vm.$t('message.page-not-found-description')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }